import { getMembershipId } from '@/utils/extract-user-data';
import { generatePartnerQueryUrl } from '@/hooks/use-get-partners/use-get-partners.utils';
import { UserProfile } from '@auth0/nextjs-auth0/client';
import { COLLECTION_MECHANIC } from '../../../models/collection-mechanic/collection-mechanic.types';
import { COLLECTION_METHOD_PDP } from '../partner-promotional-banner/partner-promotional-banner.types';
import { PartnerInfoProperties, TabEntry } from './partner-info.types';

export const sortTabs = ([keyA]: TabEntry, [keyB]: TabEntry) => {
  if (keyA === COLLECTION_MECHANIC.EStore) {
    return -1;
  }
  if (keyB === COLLECTION_MECHANIC.EStore) {
    return 1;
  }
  return 0;
};

export const showPromotionBannerByCollectionMethod = (
  activeCollectionMethod: COLLECTION_MECHANIC,
  collectionMethod?: COLLECTION_METHOD_PDP | null,
) => {
  if (collectionMethod === COLLECTION_METHOD_PDP.Any) {
    return true;
  }

  switch (activeCollectionMethod) {
    case COLLECTION_MECHANIC.EStore: {
      return collectionMethod === COLLECTION_METHOD_PDP.Online;
    }
    case COLLECTION_MECHANIC.CLO: {
      return collectionMethod === COLLECTION_METHOD_PDP.InStore;
    }
    case COLLECTION_MECHANIC.Manual: {
      return collectionMethod === COLLECTION_METHOD_PDP.Manual;
    }
    default: {
      return false;
    }
  }
};

export const formattedCtaLabelShopNow = (
  ctaLabel: string,
  isUserLoggedIn: boolean,
  ctaTextOverwrite: string,
  shopNowLoggedOutCtaLabel?: string,
): string => {
  const baseLabel = ctaTextOverwrite || ctaLabel;
  return isUserLoggedIn
    ? baseLabel
    : `${shopNowLoggedOutCtaLabel ?? ''} ${baseLabel?.toLowerCase()}`.trim();
};

export const formattedCtaLabelNotShopNow = (
  cardText: string,
  ctaTextOverwrite: string,
  isUserLoggedIn: boolean,
  shopNowLoggedOutCtaLabel?: string,
  isLoginRequired?: boolean,
): string => {
  if (isLoginRequired && !isUserLoggedIn && ctaTextOverwrite) {
    return `${shopNowLoggedOutCtaLabel ?? ''} ${ctaTextOverwrite.toLowerCase()}`.trim();
  }
  if (ctaTextOverwrite) {
    return ctaTextOverwrite;
  }
  if (!isUserLoggedIn && shopNowLoggedOutCtaLabel && !ctaTextOverwrite) {
    return `${shopNowLoggedOutCtaLabel} ${cardText.toLowerCase()}`;
  }

  return cardText;
};

export function getCtaLinkWithParameters({
  card,
  activeCollectionMethod,
  user,
  isLoginRequired,
}: {
  card: PartnerInfoProperties['card'];
  activeCollectionMethod: COLLECTION_MECHANIC;
  user: UserProfile | undefined;
  isLoginRequired: boolean;
}) {
  const additionalUrlParameters =
    card[activeCollectionMethod]?.additionalUrlParameters;

  if (
    isLoginRequired &&
    additionalUrlParameters &&
    card[activeCollectionMethod]?.cta.link
  ) {
    const membershipId = user ? getMembershipId(user) : undefined;
    const formattedUser = { ...user, membershipId };
    const urlQueryParms = additionalUrlParameters.reduce(
      (accumulator, currentElement) => {
        const value =
          formattedUser[currentElement.value as keyof typeof formattedUser];
        if (value !== undefined) {
          return {
            ...accumulator,
            [currentElement.parameter]: value,
          };
        }
        return accumulator;
      },
      {},
    );
    return generatePartnerQueryUrl(
      card[activeCollectionMethod].cta.link,
      urlQueryParms,
    );
  }
  return card[activeCollectionMethod]?.cta.link;
}
